import { SaveButton } from "components/Buttons"
import Table from "components/Table"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Row, Col, Input, Card, CardBody, Modal, Label } from "reactstrap"
import tagsListColumns from "./tagsListColumns"
import { getUpdatedCheckedItemsList } from "utils"
import {
  createMetaTag,
  deleteMetaTag,
  getMetaTags,
  hideDeleteTagModal,
  hideMergeTagsModal,
  mergeMetaTags,
  openDeleteTagModal,
  openMergeTagsModal,
  updateMetaTag,
} from "store/actions"
import ModalComponent from "components/Modals"
import { LoadingIndicator } from "components/LoadingIndicator"
import { generatePath, withRouter } from "react-router-dom"
import { URL_PATHS } from "constants/index"

const TagsList = ({
  metaTags,
  businessUnit,
  getMetaTags,
  tableDataIsLoading,
  vendorId,
  deleteTagModalIsOpen,
  openDeleteTagModal,
  hideDeleteTagModal,
  deleteMetaTag,
  openMergeTagsModal,
  hideMergeTagsModal,
  mergeTagsModalIsOpen,
  mergeMetaTags,
  history,
}) => {
  const [searchValue, setSearchValue] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)
  const [checkedItems, setCheckedItems] = useState([])
  const [selectedItem, setSelectedItem] = useState({})
  const [openMergeModal, setOpenMergeModal] = useState(false)
  const [selectedBaseTag, setSelectedBaseTag] = useState(null)
  const [selectedTagsForMerge, setSelectedTagsForMerge] = useState([])

  useEffect(() => {
    setSearchValue("")
    setShowResetButton(false)
    setCheckedItems([])
    setSelectedItem({})
    setSelectedBaseTag(null)
    setSelectedTagsForMerge([])
  }, [businessUnit])

  const handleSearch = () => {
    if (searchValue.trim().length) {
      getMetaTags({
        search: searchValue,
        ...(businessUnit === "noBU"
          ? { hide_for_business_unit: 1 }
          : { business_unit_id: businessUnit }),
      })
      setShowResetButton(true)
    }
  }

  const handleResetSearch = () => {
    setSearchValue("")
    getMetaTags({
      ...(businessUnit === "noBU"
        ? { hide_for_business_unit: 1 }
        : { business_unit_id: businessUnit }),
    })
    setShowResetButton(false)
  }

  const onDeleteTag = item => {
    setSelectedItem(item)
    openDeleteTagModal()
  }

  const actions = [
    {
      name: "Edit",
      onClick: item => {
        history?.push(generatePath(URL_PATHS.EDIT_TAG, { id: item?.id }))
      },
      icon: "bx bx-edit",
      isAvailable: true,
    },
    {
      name: "Delete",
      onClick: onDeleteTag,
      icon: "bx bx-trash",
      isAvailable: true,
    },
  ]

  const handleCheckItem = (item, checked) => {
    let checkedItemsList = getUpdatedCheckedItemsList(
      item,
      checked,
      checkedItems
    )
    setCheckedItems(checkedItemsList)
  }

  const handleCheckAllItems = (items, checked) => {
    let list = []
    if (checked) {
      for (let i = 0; i < items.length; i++) {
        list.push(items[i].id)
      }
    }
    setCheckedItems(list)
  }

  const handleDeleteTag = () => {
    deleteMetaTag({
      id: selectedItem?.id,
      callback: () => {
        hideDeleteTagModal()
        getMetaTags({
          ...(searchValue.trim().length ? { search: searchValue } : {}),
          ...(businessUnit === "noBU"
            ? { hide_for_business_unit: 1 }
            : { business_unit_id: businessUnit }),
        })
      },
    })
  }

  const handleMergeTags = () => {
    mergeMetaTags({
      values: {
        primary_tag: selectedBaseTag?.id,
        tags: selectedTagsForMerge,
        vendor_id: vendorId,
      },
      callback: () => {
        setOpenMergeModal(false)
        hideMergeTagsModal()
        getMetaTags({
          ...(searchValue.trim().length ? { search: searchValue } : {}),
          ...(businessUnit === "noBU"
            ? { hide_for_business_unit: 1 }
            : { business_unit_id: businessUnit }),
        })
        setSelectedBaseTag(null)
        setSelectedTagsForMerge([])
        setCheckedItems([])
      },
    })
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <Row className="d-flex justify-content-center my-3">
            <Col sm={6} md={5} xl={3} className="my-1">
              <Input
                value={searchValue}
                onChange={event => {
                  setSearchValue(event.target.value)
                }}
                placeholder="Search"
              />
            </Col>
            <Col xs="auto" className="my-1">
              <SaveButton
                type="button"
                fullWidth={true}
                content="Search"
                onClick={handleSearch}
              />
            </Col>
            {showResetButton && (
              <Col xs="auto" className="my-1">
                <SaveButton
                  fullWidth={true}
                  type="button"
                  content="Reset"
                  color="light"
                  onClick={handleResetSearch}
                />
              </Col>
            )}
          </Row>
          <Row>
            <Col>
              <span style={{ alignSelf: "center", paddingRight: "7px" }}>
                Select 2 or more tags
              </span>
              <SaveButton
                disabled={!(checkedItems?.length >= 2)}
                type="button"
                content="Merge"
                onClick={() => {
                  setSelectedTagsForMerge(
                    metaTags.filter(tag => checkedItems.includes(tag.id))
                  )
                  setOpenMergeModal(true)
                }}
              />
            </Col>
          </Row>
          <Row className={"my-3"}>
            <Col>
              {tableDataIsLoading ? (
                <LoadingIndicator />
              ) : (
                <Table
                  columns={tagsListColumns()}
                  data={metaTags}
                  actions={actions}
                  withCheckboxes={true}
                  onCheckItem={handleCheckItem}
                  onCheckAllItems={handleCheckAllItems}
                  loadingData={tableDataIsLoading}
                />
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
      <ModalComponent
        open={deleteTagModalIsOpen}
        onClose={hideDeleteTagModal}
        title={`Delete Meta Tag - ${selectedItem?.tag}`}
      >
        <Row>
          <h5>Are you sure you want to delete this meta tag?</h5>
        </Row>
        <Row className="mt-3">
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              color="danger"
              content="Cancel"
              onClick={hideDeleteTagModal}
            />
          </Col>
          <Col>
            <SaveButton
              type="button"
              content="Delete"
              fullWidth={true}
              onClick={handleDeleteTag}
            />
          </Col>
        </Row>
      </ModalComponent>
      <Modal
        isOpen={openMergeModal}
        toggle={() => setOpenMergeModal(false)}
        centered={true}
        size="sm"
        onClosed={() => {
          setSelectedBaseTag(null)
        }}
        scrollable={true}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Merge Tags</h5>
        </div>
        <div className="modal-body">
          <Row style={{ maxHeight: "350px" }}>
            {selectedTagsForMerge.map((tag, index) => (
              <Label key={tag.id}>
                <Input
                  defaultChecked={index === 0}
                  name="mergeTags"
                  type="radio"
                  value={tag.id}
                  onChange={() => {
                    setSelectedBaseTag(tag)
                  }}
                />
                {"  "}
                {`${tag.tag} (${
                  tag.comm_count + tag.events_count + tag.users_count
                })`}
              </Label>
            ))}
          </Row>
        </div>
        <div>
          <Row className="my-3 px-2">
            <Col>
              <SaveButton
                type="button"
                fullWidth={true}
                color="danger"
                content="Cancel"
                onClick={() => setOpenMergeModal(false)}
              />
            </Col>
            <Col>
              <SaveButton
                type="button"
                content="Merge Tags"
                fullWidth={true}
                onClick={() => {
                  if (!selectedBaseTag) {
                    setSelectedBaseTag(selectedTagsForMerge[0])
                  }
                  openMergeTagsModal()
                }}
              />
            </Col>
          </Row>
        </div>
      </Modal>
      <ModalComponent
        open={mergeTagsModalIsOpen}
        onClose={hideMergeTagsModal}
        title="Merge Tags"
      >
        <Row>
          <p>
            Are you sure you want to remove{" "}
            {selectedTagsForMerge
              .filter(tag => selectedBaseTag?.id !== tag.id)
              .map((tag, index) =>
                index === checkedItems.length - 1 ? tag.tag : `${tag.tag}, `
              )}{" "}
            tag(s) and merge them into the "{selectedBaseTag?.tag}" tag? <br />{" "}
            This cannot be undone.
          </p>
        </Row>
        <Row className="mt-3">
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              color="danger"
              content="Cancel"
              onClick={hideMergeTagsModal}
            />
          </Col>
          <Col>
            <SaveButton
              type="button"
              content="Confirm Merge"
              fullWidth={true}
              onClick={handleMergeTags}
            />
          </Col>
        </Row>
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  metaTags: state.Tags.metaTags,
  tableDataIsLoading: state.Tags.tableDataIsLoading,
  vendorId: state.Login.vendorId,
  deleteTagModalIsOpen: state.Tags.deleteTagModalIsOpen,
  mergeTagsModalIsOpen: state.Tags.mergeTagsModalIsOpen,
})

const mapDispatchToProps = dispatch => ({
  getMetaTags: values => dispatch(getMetaTags(values)),
  createMetaTag: values => dispatch(createMetaTag(values)),
  openDeleteTagModal: () => dispatch(openDeleteTagModal()),
  hideDeleteTagModal: () => dispatch(hideDeleteTagModal()),
  deleteMetaTag: values => dispatch(deleteMetaTag(values)),
  updateMetaTag: values => dispatch(updateMetaTag(values)),
  openMergeTagsModal: () => dispatch(openMergeTagsModal()),
  hideMergeTagsModal: () => dispatch(hideMergeTagsModal()),
  mergeMetaTags: values => dispatch(mergeMetaTags(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TagsList))
